import PaymentDC, { ContactPaymentTotalDC } from './PaymentDC';
import PaymentEntity, { ContactPaymentTotal } from './PaymentEntity';

const toMillis = (value: number | null | undefined): number | null =>
  value != null ? value * 1000 : null;

const toSeconds = (value: number): number => Math.floor(value / 1000);

export const mapPaymentDCToEntity = (dc: PaymentDC, workspaceId: string): PaymentEntity => ({
  uuid: dc.uuid,
  workspaceId,
  proformaInvoiceId: dc.proforma_invoice_id,
  contactId: dc.contact_id ?? null,
  amount: dc.amount,
  receivedAt: dc.received_at * 1000,
  createdAt: toMillis(dc.created_at),
  updatedAt: toMillis(dc.updated_at),
  createdBy: dc.created_by ?? null,
  updatedBy: dc.updated_by ?? null,
});

export interface PaymentDraft {
  uuid: string;
  proformaInvoiceId: string;
  amount: number;
  // Milliseconds.
  receivedAt: number;
}

/**
 * Body of POST /payments. The server stamps created_at and updated_at itself, so
 * a client clock running behind cannot make a write lose to an older one.
 */
export const mapPaymentDraftToCreatePayload = (draft: PaymentDraft) => ({
  uuid: draft.uuid,
  proforma_invoice_id: draft.proformaInvoiceId,
  amount: draft.amount,
  received_at: toSeconds(draft.receivedAt),
});

/** Body of PATCH /payments: only the fields the server lets a client change. */
export const mapPaymentDraftToUpdatePayload = (draft: PaymentDraft) => ({
  uuid: draft.uuid,
  amount: draft.amount,
  received_at: toSeconds(draft.receivedAt),
});

export const mapContactPaymentTotalDCToEntity = (
  dc: ContactPaymentTotalDC
): ContactPaymentTotal => ({
  contactId: dc.contact_id,
  currency: dc.currency,
  paymentsReceived: dc.payments_received,
  totalContractValue: dc.total_contract_value,
});
